import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32c3ea70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tableTitle" }
const _hoisted_2 = { class: "tableCentent box1" }
const _hoisted_3 = { class: "flex content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "tableTitle" }
const _hoisted_6 = { class: "flex content2" }

import i18n from "@/lang";
import store from "@/store";
import { watch, computed, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'tableBox',
  setup(__props) {

const appLanguage: any = computed(() => store.getters.getAppLanguage);
const isMobile = store.state.isMobile;
const $t = i18n.global.t;
const getFastList = () => {
  return [
    {
      name: $t("pointsMall.fastName[0]"),
      centent: "20" + " " + $t("pointsMall.fastSocre[0]"),
    },
    {
      name: $t("pointsMall.fastName[1]"),
      centent: "50" + " " + $t("pointsMall.fastSocre[1]"),
    },
    {
      name: $t("pointsMall.fastName[2]"),
      centent: "10" + " " + $t("pointsMall.fastSocre[2]"),
    },
    {
      name: $t("pointsMall.fastName[3]"),
      centent: "200" + " " + $t("pointsMall.fastSocre[3]"),
    },
  ];
};
const getregisterList = () => {
  return [
    {
      name: $t("pointsMall.registertName[0]"),
      centent: "30" + " " + $t("pointsMall.registerSocre"),
    },
    {
      name: $t("pointsMall.registertName[1]"),
      centent: "20" + " " + $t("pointsMall.registerSocre"),
    },
  ];
};
const fastLists = ref();
const registerLists = ref();
fastLists.value = getFastList();
registerLists.value = getregisterList();
watch(
  () => store.getters.getAppLanguage,
  () => {
    fastLists.value = getFastList();
    registerLists.value = getregisterList();
  },
  {
    deep: true,
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(["tableBoxPc", _unref(isMobile) ? 'tableBoxM' : ''])
  }, [
    _createElementVNode("li", _hoisted_1, _toDisplayString(_unref($t)("pointsMall.fast")), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fastLists.value, (item, index) => {
      return (_openBlock(), _createElementBlock("li", { key: index }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1),
            _createElementVNode("div", null, _toDisplayString(item.centent), 1)
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("li", _hoisted_5, _toDisplayString(_unref($t)("pointsMall.register")), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registerLists.value, (item, index) => {
      return (_openBlock(), _createElementBlock("li", { key: index }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, _toDisplayString(item.name), 1),
          _createElementVNode("div", null, _toDisplayString(item.centent), 1)
        ])
      ]))
    }), 128))
  ], 2))
}
}

})